module.exports = __webpack_public_path__ + "2a81f6503795a8833177ef4c10426a29.jpg";